// extracted by mini-css-extract-plugin
export default {"overlayDefault":"overlayDefault__Overlay__blK-Z"};